// @core/api/endpoints/affiliate/delete_postback.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  DeletePostbackResponse,
} from '../../../types/affiliate';

const BASE_PATH = '/affiliate';

/**
 * Delete postback
 * Permanently deletes the specified postback.
 */
export async function DeletePostback(
  postback_id: string,
  options?: RequestOptions
): Promise<DeletePostbackResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/postbacks/:postback_id`;
  requestPath = requestPath.replace(':postback_id', encodeURIComponent(postback_id));
  const requestOptions = options;
  return client.delete<DeletePostbackResponse>(requestPath, requestOptions);
}
